import User from "./User.js";

/**
 *    `unknownUser` is the type of user for not logged users.
 *    It acts as a Null Pattern object.
 */
export default class UnknownUser extends User {
	constructor(spec) {
		super(spec);
		this._name = "";
	}

	isUnknownUser() {
		return true;
	}
}
